import React, { Component } from 'react';
import './HeaderRow.css';
import Label from '../label/Label';

export default class HeaderRow extends Component {
	renderColumns() {
		let cols = [];
		for (let i in this.props.columns) {
			let column = this.props.columns[i];
			cols.push(
				<div key={column.label} className="column-header">
					<Label black>{column.label}</Label>
				</div>
			);
		}
		return cols;
	}

	render() {
		return <div className="g-header-row">{this.renderColumns()}</div>;
	}
}



// WEBPACK FOOTER //
// ./src/components/headerRow/HeaderRow.jsx